const template = require('./mainContainer.html');
require('./mainContainer.scss');
const logger = require('../../common/logging.config');

class MainContainerController {

	constructor($scope, $stateParams, userProfileService, homepageDataService, tenantRegistryService, shellUtil, shutterstockService) {
		this.homepageDataService = homepageDataService;
		this.shutterstockService = shutterstockService;
		this.shellUtil = shellUtil;
		this.$scope = $scope;

		this.readMoreLink = 'https://www.ibm.com/blogs/watson-customer-engagement/2018/05/17/ibm-shutterstock-ai-building-engaging-digital-experiences-just-got-easier/';
		this.isLayoutFetched = false;

		this.isAboutPage = $stateParams.about;

        // lookup the id of the current user
		userProfileService.getCurrentUserData().then(
			(data) => {
				//const userId = data.id;
				const userRole = data.roles[0];

				// get the WCH tier we are running
				tenantRegistryService.getTenantInformation().then(
					(tenantData) => {

						this.fetchLayout(userRole, tenantData.tier);

                        },
					(error) => {
						logger.error('Error retrieving tenant tier info from server: ' + error.Error);
					}
				);
			},
			(error) => {
				logger.error('Error retrieving current user id data from server: ' + error);
			}
		);

		// temporarily default to no layout until promise is delivered
		$scope.layout = [];
	}

	fetchLayout(userRole, tier) {
		const showPubGlance = true;
		const showShutterstockWidgets = true;
		const isAboutPageToggleEnabled = this.shellUtil.isToggleOn('aboutPage');

		//Check if shutterstock license is available for this tenant
        return this.shutterstockService.getShutterstockEnabled().then(
            (data) =>{
                // Bootstrap shutterstock widgets if you have shutterstock license and not in Trial tenant
                if (tier !== 'Trial' && data && data.licenses && data.enabled ===  true && data.licenses.length === 2){
                	let image_level = data.licenses[0].level;
                    let footage_level = data.licenses[1].level;
					this.$scope.layout = this.homepageDataService.getUserLayout(userRole, tier.toLowerCase(), showPubGlance, showShutterstockWidgets, image_level, footage_level, isAboutPageToggleEnabled);
					this.isLayoutFetched = true;
                    return true;
                }
                // Don't load shutterstock widgets if you don't have license or in Trial
                else{
					this.$scope.layout = this.homepageDataService.getUserLayout(userRole, tier.toLowerCase(), showPubGlance, false, null, null, isAboutPageToggleEnabled);
					this.isLayoutFetched = true;
                    return false;
                }
            },
            (error) =>{
                logger.error('Error retrieving shutterstock info: ' + error);
                // get the layout for that user
				this.$scope.layout = this.homepageDataService.getUserLayout(userRole, tier.toLowerCase(), showPubGlance, false, null, null, isAboutPageToggleEnabled);
				this.isLayoutFetched = true;
                return false;
            }
        );
	}
};

module.exports = {
	templateUrl: template,
	controller: ["$scope", "$stateParams", "userProfileService", "homepageDataService", "tenantRegistryService", "shellUtil", "shutterstockService",  MainContainerController]
};



// WEBPACK FOOTER //
// ./app/components/mainContainer/mainContainer.component.js